import api from './api-config';

const BASE = '/customers';

export const getCustomers = async (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.skip !== undefined) searchParams.append('skip', params.skip);
    if (params.limit !== undefined) searchParams.append('limit', params.limit);
    if (params.search) searchParams.append('search', params.search);
    if (params.country) searchParams.append('country', params.country);
    if (params.sort_by) searchParams.append('sort_by', params.sort_by);
    if (params.sort_order) searchParams.append('sort_order', params.sort_order);

    const response = await api.get(`${BASE}?${searchParams}`);
    return response.data;
};

export const getCustomer = async (customerId) => {
    const response = await api.get(`${BASE}/${customerId}`);
    return response.data;
};
